import * as React from 'react';

export default class exitIcon extends React.PureComponent<{}> {

    public render() {
        return (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.8125 12.0215H3.77148" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.8848 9.10547L15.8128 12.0215L12.8848 14.9375" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path opacity="0.4" d="M8.50391 7.38848V6.45548C8.50391 4.42048 10.1529 2.77148 12.1889 2.77148H17.0729C19.1029 2.77148 20.7479 4.41648 20.7479 6.44648V17.5865C20.7479 19.6215 19.0979 21.2715 17.0629 21.2715H12.1779C10.1489 21.2715 8.50391 19.6255 8.50391 17.5965V16.6545" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

        );
    }
}
